import { delay } from 'redux-saga';
import { call } from 'redux-saga/effects';

export function* callWithDelay(fn, action) {
  // yield call(delay, TYPING_DEBOUNCE_INTERVAL);
  yield call(delay, 250);
  yield call(fn, action);
}
